import { createContext, PropsWithChildren, useContext } from "react";

const FormFileUploadEnquiryContext = createContext<string | null>(null);

export function FormFileUploadEnquiryProvider({
  enquiryId,
  children,
}: PropsWithChildren<{ enquiryId?: string | null }>) {
  const value =
    typeof enquiryId === "string" && enquiryId.trim().length > 0 ? enquiryId.trim() : null;
  return (
    <FormFileUploadEnquiryContext.Provider value={value}>{children}</FormFileUploadEnquiryContext.Provider>
  );
}

export function useFormFileUploadEnquiryIdOptional(): string | null {
  return useContext(FormFileUploadEnquiryContext);
}
